export const validatePrefetchImage = (url: string): Promise<boolean> => {
  return new Promise((resolve) => {
    if (!url) return resolve(false);

    const img = new Image();
    const timeout = setTimeout(() => resolve(false), 5000);

    img.onload = () => {
      clearTimeout(timeout);
      resolve(true);
    };

    img.onerror = () => {
      clearTimeout(timeout);
      resolve(false);
    };

    img.src = url;
  });
};
